import loadable from 'utils/loadable';

export const EvaluatorScorecardPage = loadable(() => import('./index'), {
  fallback: null,
});
